module.exports = __webpack_public_path__ + "static/img/satanizador-1.2f39926.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/satanizador-1.jpg
// module id = esww
// module chunks = 1